import {useTranslation} from 'react-i18next';
import type {CustomerPayment} from '@worki/shared';
import {CheckCircle2,Clock,CircleX} from 'lucide-react';

export function CustomerPaymentStatus({payment}:{payment:CustomerPayment}) {
  const {t}=useTranslation();
  const Icon=payment.status==='paid'?CheckCircle2:payment.status==='pending'?Clock:CircleX;
  return <div className="space-y-2">
    <p className={`inline-flex items-center gap-2 text-sm font-semibold ${payment.status==='paid'?'text-success':payment.status==='pending'?'text-muted-foreground':'text-destructive'}`}>
      <Icon className="h-4 w-4" aria-hidden/>{t(`customerPayments.${payment.status}`)}
    </p>
    {payment.status==='paid'&&payment.receiptStatus==='pending'&&<p className="text-xs text-muted-foreground" role="status">{t('customerPayments.receiptPending')}</p>}
    {payment.receipt&&<a className="block text-sm text-primary underline" href={payment.receipt.url} target="_blank" rel="noopener noreferrer">{t('customerPayments.receipt')}{payment.receipt.number?` · ${payment.receipt.number}`:''}</a>}
    {(payment.checkoutStatus==='creating'||payment.checkoutStatus==='uncertain')&&<p role="status" className="text-xs text-warning">{t('customerPayments.uncertain')}</p>}
  </div>;
}
